import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import ApplicantReviewStyle from "assets/jss/material-dashboard-react/views/goldRatesStyle.js";
import { useDispatch, useSelector } from "react-redux";
import styles from "assets/jss/material-dashboard-react/views/pageStyle";
import { Visibility } from "@material-ui/icons";
import { VisibilityOff } from "@material-ui/icons";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import { saveLoanApplicantDetails } from "store/reducers/LoanDetail/LoanDetailSlice";
import { Grid, IconButton } from "@material-ui/core";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ToastModal from "views/components/ToastModal";
import { useOutletContext } from "react-router-dom";
import { parseAndSetFlag } from "utils/Utils";
import { toCamelCase } from "utils/Utils";
import { showMaskedCodeLos } from "assets/properties/properties";
const useStyles = makeStyles(styles);

const ApplicantReview = ({
  loanApplicationId,
  classes,
  subStatus,
  loanAccountNumber,
}) => {
  const [record, setRecord] = useState("");
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [callInProgress, setCallInProgress] = useState(false);
  const { authToken } = useSelector((state) => state.login.authData);
  const [showVisibilityOffDocumentNumber, setShowVisibilityOffDocumentNumber] =
    useState(false);
  const [showVisibilityOffAadharNumber, setShowVisibilityOffAadharNumber] =
    useState(false);
  const [showErrorAadharNumber, setShowErrorAadharNumber] =
    useState(false);
  const [showVisibilityOffMobileNumber, setShowVisibilityOffMobileNumber] =
    useState(false);
  const [showErrorDocumentNumber, setShowErrorDocumentNumber] = useState(false);
  const [showErrorMobileNumber, setShowErrorMobileNumber] = useState(false);
  const [showErrorDocumentNumberMsg, setShowErrorDocumentNumberMsg] = useState("");
  const [showErrorMobileNumberMsg, setShowErrorMobileNumberMsg] = useState("");
  const [showErrorAadharNumberMsg, setShowErrorAadharNumberMsg] =
  useState("");
  const [documentName,setDocumentName]=  useState("");
  const [documentNameList,setDocumentNameList]=useState([]);
  const outletData = useOutletContext();
  const showPreFixName = parseAndSetFlag(outletData?.showApplicantPreFixName);
  const enableCamOnLoanDetails = parseAndSetFlag(outletData?.enabledCreditAssessmentOnLoanDetails);
  const showCustomerType = parseAndSetFlag(outletData?.showCustomerType);
  const sideBarData = JSON.parse(sessionStorage.getItem("sideBarData") || "{}");
  const losListData = sideBarData?.losListData || [];
  const checkMaskedDataEnabled = losListData?.find((item)=> item?.code === showMaskedCodeLos);

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  useEffect(()=>{
    getAllDocumentNames();
  },[])
  const getAllDocumentNames = async () =>{
    setCallInProgress(true)
    const result = await apiHandler({
      url: endpoint.GET_ALL_DOCUMENT_NAMES,
      authToken: authToken,
    });
    if(result?.data?.error_code){
      toastUpdate("Error", result?.data?.user_description, true);
      setCallInProgress(false)
    }else {
      setDocumentNameList(result?.data);
      await GetApplicantData(result?.data);
    }
  }
  const dispatch = useDispatch();
  const getAddress = (addresss) => {
    let address = "";
    if (addresss?.houseNumber !== "") {
      address = address + addresss?.houseNumber;
    }
    if (addresss?.street !== "") {
      if (address !== "") {
        address = address + ", ";
      }
      address = address + addresss?.street;
    }
    if (addresss?.locality !== "") {
      if (address !== "") {
        address = address + ", ";
      }
      address = address + addresss?.locality;
    }
    if (addresss?.postOffice !== "") {
      if (address !== "") {
        address = address + ", ";
      }
      address = address + addresss?.postOffice;
    }
    if (addresss?.villageTownCity !== "") {
      if (address !== "") {
        address = address + ", ";
      }
      address = address + addresss?.villageTownCity;
    }
    if (addresss?.state !== "") {
      if (address !== "") {
        address = address + ", ";
      }
      address = address + addresss?.state;
    }
    if (addresss?.district !== "") {
      if (address !== "") {
        address = address + ", ";
      }
      address = address + addresss?.district;
    }
    if (addresss?.pincode !== "") {
      if (address !== "") {
        address = address + ", ";
      }
      address = address + addresss?.pincode;
    }

    return address;
  };
  const handleClickShowPassword = async (
    viewType,
    loanAccountNumber,
    lastFourDigits,
    authToken,
    setShowError,
    setShowVisibilityOff,
    setErrorMsg
  ) => {
    const result = await apiHandler({
      url: endpoint.SHOW_MASKED + loanAccountNumber + "?view=" + viewType + "&lastFourDigit=" + lastFourDigits ,
      authToken: authToken,
      method: "POST",
    });
    if(result?.data?.error_code === 403){
      setErrorMsg(`This role doesn't have access`)
      setShowError(true) 
    }else if(result?.data?.error_code){
      setErrorMsg(result?.data?.user_description)
      setShowError(true) 
    }
    else{
      setShowVisibilityOff(true);
    }
  };

  const handleClickHidePassword = (setShowVisibilityOff,setShowError) => {
    setShowVisibilityOff(false);
    setShowError(false);
    return;
  };
  const getAddharnumber = (input) => {
    input = input.replace(/^(\d{0,4})(\d{0,3})/, "$1 $2");
    var prefix = input.substr(0, input.length - 4);
    var suffix = input.substr(-4);
    var masked = prefix.replace(/\d/g, "*");
    var a = masked + suffix;
    return a;
  };
 
  const GetApplicantData = async (data) => {
    //APPLICANT_GETDATA
    const result = await apiHandler({
      url: endpoint.APPLICANT_GETDATA + loanApplicationId,
      authToken: authToken,
    });
    if (result?.data?.error_code) {
      toastUpdate("Error", "please Provide correct applicant data", true);
      setCallInProgress(false);
    } else {
      setCallInProgress(false);
      dispatch(
        saveLoanApplicantDetails({
          applicantDetails: result.data,
        })
      );
      setRecord(result.data);
      const document = data?.find(doc => doc?.value === result.data?.documentName);
      const selectedName = document?.displayName ? document?.displayName : result.data?.documentName
      setDocumentName(selectedName)
    }
  };
  const itemView = (
    label,
    value,
    icon,
    name,
    handleClickShowPassword,
    loanAccountNumber,
    lastFourDigits,
    authToken,
    showError,
    setShowError,
    showVisibilityOff,
    setShowVisibilityOff,
    errorMsg,
    setErrorMsg,
  ) => {
    return (
        <Grid item xs={5} sm={6} md={4} className={classes.fieldContaienrReview}>
            <p style={{ marginBottom: 0 }}>
                <b>{toCamelCase(label)}</b>
            </p>
            <label style={{ textTransform: 'capitalize' }}>
              {value}
                {(icon && !checkMaskedDataEnabled?.disabled) ? (
                    <>
                        {showVisibilityOff ?(
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={(e) =>{e.preventDefault();
                                  e.stopPropagation(); handleClickHidePassword(setShowVisibilityOff,setShowError)}}
                                edge="end"
                              >
                                 {" "}
                              <VisibilityOff />
                            </IconButton>
                            ):(
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={(e) =>{
                                  e.preventDefault();
                                  e.stopPropagation();
                                  handleClickShowPassword(
                                    name,
                                    loanAccountNumber,
                                    lastFourDigits,
                                    authToken,
                                    setShowError,
                                    setShowVisibilityOff,
                                    setErrorMsg,
                                  )}
                                }
                                edge="end"
                            >
                              {" "}
                               <Visibility />
                            </IconButton>
                        )}
              {showError && <span style={{color:'red', fontSize:'10px', textAlign:'left', width:'100%', fontWeight:700}}>{errorMsg}</span>}
                    </>
                   ) : (
                    ""
                )}
            </label>
        </Grid>
    );
};

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        className={classes.inputFieldContainer}
      >
        <h2 className={classes.header} style={{ fontSize: "1.5rem" }}>
          Applicant Details
        </h2>
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
        {showPreFixName && itemView(
            "Applicant Name PreFix",
            record?.applicantNamePrefix || "NA"
          )}
          {itemView(
            "Applicant Name",
            toCamelCase(record?.nameOnAdhaar) || toCamelCase(record?.nameOnPanCard) || "NA"
          )}
          {record.adhaarNumber && record.adhaarNumber !== "" ? (
             itemView(
              "AADHAAR NUMBER",
              showVisibilityOffAadharNumber
              ? record?.adhaarNumber
              : record?.adhaarNumber?.replace(/\d(?=\d{4})/g, "*"),
              loanAccountNumber ? 
              "icon" :
              "",
              "Aadhar Card" || "NA",
              handleClickShowPassword,
              loanAccountNumber,
              Number(record?.adhaarNumber) % 10000,
              authToken,
              showErrorAadharNumber,
              setShowErrorAadharNumber,
              showVisibilityOffAadharNumber,
              setShowVisibilityOffAadharNumber,
              showErrorAadharNumberMsg,
                setShowErrorAadharNumberMsg,
            )
          ) : (
            <>
              {itemView("DOCUMENT NAME", documentName || "NA")}
              {itemView(
                "DOCUMENT NUMBER",
                (documentName !== "Aadhar Card") 
                  ? record?.documentNumber
                  : showVisibilityOffDocumentNumber
                  ? record?.documentNumber
                  : record?.documentNumber?.replace(/\d(?=\d{4})/g, "*"),
                documentName === "Aadhar Card" && loanAccountNumber
                  ? "icon"
                  : "",
                documentName || "NA",
                handleClickShowPassword,
                loanAccountNumber,
                Number(record?.documentNumber) % 10000,
                authToken,
                showErrorDocumentNumber,
                setShowErrorDocumentNumber,
                showVisibilityOffDocumentNumber,
                setShowVisibilityOffDocumentNumber,
                showErrorDocumentNumberMsg,
                setShowErrorDocumentNumberMsg,
              )}
              {record?.documentExpiry &&
                itemView("DOCUMENT EXPIRY", record.documentExpiry || "NA")}
            </>
          )}
          {subStatus !== "PRE_PLEDGE" &&
            itemView("APPLICANT PAN NAME", record.nameOnPanCard || "NA")}
          {subStatus !== "PRE_PLEDGE" &&
            itemView("PAN NUMBER", record.panNumber || "NA")}
          {itemView("DATE OF BIRTH", record.dob || "NA")}
          {itemView("FATHER NAME", toCamelCase(record.fatherName) || "NA")}
          {itemView("MOTHER NAME", toCamelCase(record.motherName) || "NA")}
          {itemView("GENDER", toCamelCase(record.gender) || "NA")}
          {itemView("Marital Status", toCamelCase(record.maritalStatus) || "NA")}
          {itemView("No. of Members", record.memberCount || "NA")}
          {itemView("Spouse Name", toCamelCase(record.spouseName) || "NA")}
          {itemView(enableCamOnLoanDetails ? "Monthly Income" : "Income", record.applicantAnnualIncome || "NA")}
          {itemView("OCCUPATION", toCamelCase(record.occupationType) || "NA")}
          {itemView("PURPOSE OF LOAN", toCamelCase(record.purposeOfLoan) || "NA")}
          {showCustomerType && (itemView("Customer Type", toCamelCase(record.customerType) || "NA"))}

          {itemView(
            "MOBILE NUMBER",
            showVisibilityOffMobileNumber
              ? record?.mobileNumber
              : record?.mobileNumber?.replace(/\d(?=\d{4})/g, "*"),
              loanAccountNumber ? 
            "icon" :
            "",
            "mobile" || "NA",
            handleClickShowPassword,
            loanAccountNumber,
            Number(record?.mobileNumber) % 10000,
            authToken,
            showErrorMobileNumber,
            setShowErrorMobileNumber,
            showVisibilityOffMobileNumber,
            setShowVisibilityOffMobileNumber,
            showErrorMobileNumberMsg,
            setShowErrorMobileNumberMsg
          )}
          {itemView(
            "ALTERNATE MOBILE NUMBER",
            record?.alternateMobileNumber || "NA"
          )}
          {itemView("PERMANENT ADDRESS", getAddress(record?.addresses?.[0]))}
          {itemView(
            "CORRESPONDENCE ADDRESS",
            record?.addresses?.length > 1  ?  getAddress(record?.addresses?.[1]) : "NA"
          )}
          {itemView("EMAIL", record.email || "NA")}
          {itemView("GST NUMBER", record.gstNumber || "NA")}
          {itemView("GST STATE", record.gstState || "NA")}
          {itemView("Profiling", record.dueDiligence || "NA")}
        </Grid>
      </Grid>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
       {callInProgress && (
          <CircularProgresss callInProgress={callInProgress} />
        )}
    </Grid>
  );
};

ApplicantReview.propTypes = {
  classes: PropTypes.object,
  loanApplicationId: PropTypes.object,
  handlecreateuserSubmit: PropTypes.func,
};

export default ApplicantReview;
